import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useLayoutEffect,
} from "react";
import { useStyles } from "./styles";
import { useParams } from "react-router-dom";
import { SocketContext } from "../../../../Services/socket";
import { TwinSpin } from "react-cssfx-loading";
import { RenderLayout } from "../../../Plugin/component";
import Cookies from "universal-cookie";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import { Action } from "../../../Plugin/component";
import { NotificationManager } from "react-notifications";
import "./styles.scss";
import { MdPermIdentity } from "react-icons/md";
import { MdOutlineArrowDownward } from "react-icons/md";
import { MdOutlineLocationOn } from "react-icons/md";
import { MdOutlineCallToAction } from "react-icons/md";
import { BsArrowDown, BsPencilFill } from "react-icons/bs";
import { MdHistory } from "react-icons/md";
import { MdOutlineDisabledVisible } from "react-icons/md";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { MdClose } from "react-icons/md";
import IconButton from "@material-ui/core/IconButton";
import ScrollToTop from "react-scroll-to-top";
import { useDebounce } from '../../../../hooks';
import moment from "moment";

const cookies = new Cookies();

export default function PlanHandleStepComponent(props) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [handleStep, sethandleStep] = React.useState(0);
  const [isChoosenStep, setIsChoosenStep] = useState(0);
  const [steps, setsteps] = React.useState();
  const [DataPlanTypeConfiguration, setDataPlanTypeConfiguration] =
    React.useState();
  const { id } = useParams();
  // eslint-disable-next-line
  const [Operation, setOperation] = React.useState();
  const [handleStaff, sethandleStaff] = React.useState();
  const [status, setStatus] = React.useState();
  const socket = useContext(SocketContext);
  const [open, setOpen] = useState(false);
  const [actions, setActions] = React.useState();
  const [isLoading, setIsLoading] = React.useState(false);//state này
  const [openM, setOpenM] = React.useState(false);
  const [dataPlanTypeConfig, setDataPlanTypeConfig] = React.useState();
  const [itemAction, setItemAction] = React.useState();
  const [nameAction, setNameAction] = React.useState();
  const [titleDialog, setTitleDialog] = React.useState();
  const [dataHistory, setDataHistory] = useState();
  // setIsOpenHistory dùng để set isOpenHistory
  const [isOpenHistory, setIsOpenHistory] = useState(false);//State này

  const [isOpenInfoDisable, setIsOpenInfoDisable] = React.useState(true);

  const currentData = props.DataPlanHandleStep;
  const [statusHistory, setStatusHistory] = React.useState();

  const [anchorEl, setAnchorEl] = useState()
  const [shoboxMoreAnchorEl, setShoboxMoreAnchorEl] = useState()
  const [isDown, setDown] = useState(false);
  const [currentEmailAzure, setCurrentEmailAzure] = useState([])
  const [currentKeyword, setCurrentKeyword] = useState("a");
  const [currentValue, setCurrentValue] = useState([]);

  const debounce = useDebounce(currentKeyword, 800)
  // const [heightScroll, setHeightScroll] = useState();

  //Set array data while Data Plan Handle have type Azure Email

  useEffect(() => {
    if (DataPlanTypeConfiguration && DataPlanTypeConfiguration.length > 0) {
      let array = []
      // eslint-disable-next-line
      DataPlanTypeConfiguration.map((dataPlan, index) => {
        if (dataPlan.type === "Azure Email" && (dataPlan.content !== "" || dataPlan.content)) {
          array.push({ id: index, name: dataPlan.name, data: dataPlan.content?.split("*") })
        } else if (dataPlan.type === "Azure Email" && (dataPlan.content === "" || dataPlan.content === null)) {
          array.push({ id: index, name: dataPlan.name, data: [] })
        }
      })
      setCurrentEmailAzure(array)
    }
  }, [DataPlanTypeConfiguration])


  useEffect(() => {
    props.GetDataEmailAzureByName && props.GetDataEmailAzureByName(debounce)
    // eslint-disable-next-line
  }, [debounce]);

  useEffect(() => {
    if (props.DataEmailAzure && props.DataEmailAzure?.Data && props.DataEmailAzure?.Data.length > 0) {
      const array = []
      // eslint-disable-next-line
      props.DataEmailAzure.Data.map((value) => {
        array.push(value["EMAIL_ADDR"])
      })
      setCurrentValue(array)
    }
  }, [props.DataEmailAzure])

  const HandleCovertDateTime = useCallback((dateTime) => {
    const m = new Date(dateTime);
    const mon = m.getMonth() + 1;
    const dateString =
      m.getFullYear() + "/" + mon + "/" + (m.getDate())
    return dateString.split(" ")[0];
  }, []);

  const HandleCovertEventToDateTime = useCallback((event, type) => {
    if (type === "Datetime") {
      const m = new Date(event);
      const mon = m.getMonth() + 1;
      const dateString =
        m.getFullYear() + "/" + mon + "/" + (m.getDate())
      return `${dateString.split(" ")[0]} ${new Date(event).toLocaleTimeString('en-GB', { hour: 'numeric', minute: 'numeric' })}`;
    } else {
      return event
    }
    // eslint-disable-next-line
  }, [DataPlanTypeConfiguration]);

  const handleClickOpen = (DataPlanTypeConfiguration, item) => {
    //console.log(openM);
    // setIdModal(id);
    if (item.id === 3 || item.id === 2) {
      setNameAction("Bạn đã nhập lý do " + item.name + " chưa?");
    } else {
      setNameAction("Bạn có chắc chắn muốn " + item.name + " không?");
    }
    setDataPlanTypeConfig(DataPlanTypeConfiguration);
    setItemAction(item);
    setTitleDialog(item.name);
    setOpenM(true);
  };

  const handleClose = () => {
    setOpenM(false);
  };

  //const [showResults, setShowResults] = React.useState(false)

  useEffect(() => {
    props.GetStatusActionHistory(id);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      props.StatusActionHistory &&
      Object.keys(props.StatusActionHistory).length > 0
    ) {
      setStatusHistory(props.StatusActionHistory[0]["ActionHistory"]);

      //console.log("status history1", props.StatusActionHistory[0]["ActionHistory"]);
    }
  }, [props.StatusActionHistory]);

  useEffect(() => {
    setOpen(true);
    props.GetDataPlanHandleStep(id, 0);
    socket.on(cookies.get("usercode").email, (mess) => {
      setOpen(true);
      sethandleStaff(undefined);
      setDataPlanTypeConfiguration(undefined);
      props.GetDataPlanHandleStep(id, 0);
    });
    return () => {
      props.ClearDataPlanHandleStep();
    };
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    if (window.document.body.scrollHeight <= window.screen.availHeight) {
      setDown(true);
    }
    if (
      props.DataPlanHandleStep &&
      Object.keys(props.DataPlanHandleStep).length > 0
    ) {
      setsteps(
        props.DataPlanHandleStep.planTypeConfigurationMain &&
        props.DataPlanHandleStep.planTypeConfigurationMain.map((item) => {
          return item.stepName;
        })
      );
      let arr = [
        ...props.DataPlanHandleStep.responsePlan.filter((item) => {
          return item.typeParam !== "Input" && item.type !== "Link liên kết";
        }),
      ];

      
      props.DataPlanHandleStep.responsePlan
        .filter((item) => {
          return item.typeParam !== "Input" && item.type !== "Link liên kết";
        })// eslint-disable-next-line
        .map((item, index) => {
          if (item.data.includes("Data") && item.handleStep < 2) {
            //console.log("item",item);
            //console.log(" item.content",item.content);

            let project_name = item.content; //? JSON.parse(item.content):"";

            arr = [
              ...arr.slice(0, index),
              {
                ...arr[index],
                content: project_name,
                data: project_name,
              },
              ...arr.slice(index + 1),
            ];
          }
          if (item.data.includes("Department") && item.handleStep < 2) {
            let Department = item.content; //? JSON.parse(item.content):"";
            arr = [
              ...arr.slice(0, index),
              {
                ...arr[index],
                content: Department,
                data: Department,
              },
              ...arr.slice(index + 1),
            ];
          }
          if (item.data.includes("email") && item.handleStep < 2) {
            let email = item.content; //? JSON.parse(item.content):"";
            arr = [
              ...arr.slice(0, index),
              {
                ...arr[index],
                content: email,
                data: email,
              },
              ...arr.slice(index + 1),
            ];
          }
        });

      // const newArray = arr.map((itemArr) => (itemArr.isError = false));
      // let arayfinal = [
      //   ...arr.filter((item) => {
      //     return (
      //       item.name.includes("Project") ||
      //       item.name.includes("Phongban") ||
      //       item.name.includes("Phòng") ||
      //       item.name.includes("PM")
      //     );
      //   }),
      //   ...arr.filter((item) => {
      //     return (
      //       !item.name.includes("Project") &&
      //       !item.name.includes("Phongban") &&
      //       !item.name.includes("Phòng") &&
      //       !item.name.includes("PM")
      //     );
      //   }),
      // ];
      //let arrft = arayfinal;
      // let dataConfigFilter = arayfinal && arayfinal.filter((item) => item.name === 'Thời gian dự kiến kết thúc' && item.type === 'Datetime');
      // if (dataConfigFilter && dataConfigFilter.length > 0) {
      //   let dateconvert = moment(dataConfigFilter[0].content).add(5, 'hours').format("YYYY/M/DD hh:mm");
      //   arrft = arayfinal && arayfinal.map((item) => {
      //     return {
      //       ...item,
      //       content: item.name === 'Thời gian gia hạn' && item.type === 'Datetime' ? dateconvert.toString() : item.content
      //     }
      //   });
      // }
      let arrftcopy = arr && arr.map((item) =>{
        return {
          ...item,
          index: item.planTypeConfigurationRefID !==0 ? item.planTypeConfigurationRefID : item.planTypeConfigurationID
        }
      })
      const arraySort = arrftcopy.sort((a, b) => {
        return a.index - b.index;
    });
      setDataPlanTypeConfiguration(arraySort);
      //setDataPlanTypeConfiguration(props.DataPlanHandleStep.responsePlan.filter(item => { return item.typeParam !== "Input" && item.type !== "Link liên kết" }));
      setOperation(
        props.DataPlanHandleStep.planTypeConfigurationMain &&
        props.DataPlanHandleStep.planTypeConfigurationMain.filter((item) => {
          return item.step === activeStep + 1;
        })[0].operation
      );
      setActiveStep(props.DataPlanHandleStep.responsePlan[0].step - 1);
      setIsChoosenStep(parseInt(props.DataPlanHandleStep.responsePlan[0].step));
      sethandleStep(props.DataPlanHandleStep.responsePlan[0].handleStep - 1);
      sethandleStaff(props.DataPlanHandleStep.handleStaff);
      setStatus(props.DataPlanHandleStep.responsePlan[0].status);
      setOpen(false);
      setActions(
        props.DataPlanHandleStep.planTypeConfigurationMain.filter((item) => {
          return item.step === activeStep + 1;
        })[0].actions
      );
    }
    // eslint-disable-next-line
  }, [props.DataPlanHandleStep]);

  useEffect(() => {
    if (Object.keys(props.DataHandleStaff).length > 0) {
      const lContent = props.DataHandleStaff.map((item) => {
        return item.content;
      });
      const email = [];
      lContent.forEach((item) => {
        if (item !== null) {
          item.split("*").forEach((item1) => {
            socket.emit("send-message-by-email", { message: "", email: item1 });
            email.push(item1);
          });
        }
      });
      setIsLoading(false);
      socket.emit("send-message-by-email", { message: "", email: email });
      NotificationManager.success(`Thao tác thành công.`);
      props.GetDataPlanHandleStep(id, 0);
      props.GetHistoryByPlanID(id);
    }
    // eslint-disable-next-line
  }, [props.DataHandleStaff]);

  useEffect(() => {
    if (
      props.DataPlanHandleStep &&
      props.DataPlanHandleStep.planTypeConfigurationMain
    ) {
      setActions(
        props.DataPlanHandleStep.planTypeConfigurationMain.filter((item) => {
          return item.step === activeStep + 1;
        })[0].actions
      );
    }
    // eslint-disable-next-line
  }, [activeStep]);

  useLayoutEffect(() => {
    if (props.DataFile) {
      setDataPlanTypeConfiguration([
        ...DataPlanTypeConfiguration.slice(0, props.DataFile.index),
        {
          ...DataPlanTypeConfiguration[props.DataFile.index],
          content: props.DataFile.file,
        },
        ...DataPlanTypeConfiguration.slice(props.DataFile.index + 1),
      ]);
    }
    // eslint-disable-next-line
  }, [props.DataFile]);

  //   useEffect(() => {
  //       console.log("hehe", isLoading);
  //       if (isOpenInfoDisable) {
  //         setIsLoading(false);
  //       } else {
  //         setIsLoading(false);
  //       }

  //   }, [isOpenInfoDisable]);

  // const HandleConfirm = () => {
  //     setOpen(true);
  //     sethandleStaff(undefined);
  //     setDataPlanTypeConfiguration(undefined);
  //     props.SetDataPlanHandleStep({ PlanContent: DataPlanTypeConfiguration.filter(item => { return item.disabled === 0 }), Action: "Confirm" });
  // };

  // const HandleAssignment = () => {
  //     setOpen(true);
  //     props.SetDataPlanHandleStep({ PlanContent: DataPlanTypeConfiguration.filter(item => { return item.disabled === 0 }), Action: "Assignment" });
  // };

  // const HandleClose = () => {
  //     setOpen(true);
  //     props.SetDataPlanHandleStep({ PlanContent: DataPlanTypeConfiguration.filter(item => { return item.disabled === 0 }), Action: "Close" });
  // };

  // const HandleUndo = () => {
  //     setOpen(true);
  //     props.SetDataPlanHandleStep({ PlanContent: DataPlanTypeConfiguration.filter(item => { return item.disabled === 0 }), Action: "Undo" });
  // };

  const HandleOnChange = (e, index, Type, planTypeConfigurationID) => {
    function findOrange(fruit) {
      return fruit.planTypeConfigurationID === planTypeConfigurationID;
    }

    let oldIndex = DataPlanTypeConfiguration.findIndex(findOrange);

    //console.log("newIndex", oldIndex)

    if (Type === "File") {
      props.UploadFile(e[0], index);
    } else if (Type === "Azure Email") {
      setDataPlanTypeConfiguration([
        ...DataPlanTypeConfiguration.slice(0, index),
        {
          ...DataPlanTypeConfiguration[index],
          content: e,
        },
        ...DataPlanTypeConfiguration.slice(index + 1)
      ]);
    } else {
      setDataPlanTypeConfiguration([
        ...DataPlanTypeConfiguration.slice(0, oldIndex),
        {
          ...DataPlanTypeConfiguration[oldIndex],
          content: HandleCovertEventToDateTime(e, Type),
        },
        ...DataPlanTypeConfiguration.slice(oldIndex + 1),
      ]);
    }
  };

  const handleGetInputTextAzureEmail = useCallback((event) => {
    setCurrentKeyword(event.target.value);
  }, [])

  const handleUpdateStateDataPlanHandle = (newValue, index, type) => {
    //Only for Type Azure Email now
    if (currentEmailAzure.length > 0) {
      // eslint-disable-next-line
      currentEmailAzure.map((val) => {
        // eslint-disable-next-line
        if (val.id = index) {
          val.data = [...newValue];
        } else {
          val.data = newValue;
        }
      })
    }

    //call function set state for data plan can save into DB        
    const dataPlanHandleField = []
    // eslint-disable-next-line
    newValue.map(obj => {
      const value = obj.value
      dataPlanHandleField.push(value)
    })
    HandleOnChange(newValue.join("*"), index, type)
  }

  const handleDownload = (value) => {
    props.DownloadFile(value);
  };

  // const handleDeleteFile = (dataPlanHandleByStep, indexValue) => {
  //   const copyDataPlanHandleStep = DataPlanTypeConfiguration.map(
  //     (item, index) => {
  //       if (indexValue === index) {
  //         item.content = "";
  //       }
  //       return item;
  //     }
  //   );
  //   setDataPlanTypeConfiguration(copyDataPlanHandleStep);
  // };

  const HandelChangeStep = (index) => {
    setOpen(true);
    sethandleStaff(undefined);
    setDataPlanTypeConfiguration(undefined);
    props.GetDataPlanHandleStep(id, index + 1);
  };



  /*=============================================================================================
    Summary:     So sánh và lấy các thông tin thay đổi để lưu log và thực hiện action
    Author:      Sangvtt2
    Date:        04-04-2022 
    =============================================================================================*/

  const HandleValidateField = useCallback(
    (dataPlanTypeConfiguration, item) => {
      const newData = DataPlanTypeConfiguration.map((item) => {
        if (item.isRequired === "true" && !item.content) {
          item.isError = true;
        } else if (item.isRequired === "true" && item.content) {
          item.isError = false;
        }
        return item;
      });
      setDataPlanTypeConfiguration(newData);
      HandleNotiError(dataPlanTypeConfiguration, item);
    },
    // eslint-disable-next-line
    [DataPlanTypeConfiguration]
  );

  const HandleNotiError = useCallback(
    (dataPlanTypeConfiguration, item) => {
      const dataError = DataPlanTypeConfiguration.filter(
        (item) => item.isError === true
      );
      if (item.component === 'ADD_TIME_DEPLOY') {
        let check = DataPlanTypeConfiguration && DataPlanTypeConfiguration.filter((item) => item.name === 'Lý do gia hạn thời gian triển khai' && (item.content === '' || item.content === null));
        let dateAddTime = DataPlanTypeConfiguration && DataPlanTypeConfiguration.filter((item) => item.name === 'Thời gian gia hạn triển khai' && item.type === 'Datetime');
        let dateTimeDeployEnd = DataPlanTypeConfiguration && DataPlanTypeConfiguration.filter((item) => item.name === 'Thời gian dự kiến kết thúc' && item.type === 'Datetime');
        let dateTimeDeployStart = DataPlanTypeConfiguration && DataPlanTypeConfiguration.filter((item) => item.name === 'Thời gian dự kiến bắt đầu' && item.type === 'Datetime');
        if (check && check.length > 0) {
          NotificationManager.warning("Vui lòng nhập " + check[0].name)
          return false;
        }
        if ((dateAddTime && dateAddTime.length > 0) && (dateTimeDeployEnd && dateTimeDeployEnd.length > 0) && (dateTimeDeployStart && dateTimeDeployStart.length > 0)) {
          let dateTimeDeployEndConvert = dateTimeDeployEnd && moment(dateTimeDeployEnd[0].content).format("YYYY-MM-DD HH:mm");
          let dateTimeCompare = dateTimeDeployEnd && moment(dateTimeDeployStart[0].content).add(1, 'days').format("YYYY-MM-DD 06:00");
          let dateAddTimeConvert = dateAddTime && moment(dateAddTime[0].content).format("YYYY-MM-DD HH:mm");
          if (dateAddTimeConvert > dateTimeCompare || dateAddTimeConvert < dateTimeDeployEndConvert) {
            NotificationManager.warning("Thời gian gia hạn phải trước " + dateTimeCompare);
            return false;
          }
        }
      }
      if (dataError.length > 0) {
        NotificationManager.error(
          `Vui lòng nhập thông tin ${dataError
            .map((data) => {
              return data.name;
            })
            .join(", ")}`
        );
        return false;
      } else {
        checkAndUpdate(dataPlanTypeConfiguration, item);
      }
    },
    // eslint-disable-next-line
    [DataPlanTypeConfiguration]
  );

  const checkAndUpdate = async (updatedData, item) => {
    if (statusHistory === true) {
      //loading page when Click ButtonF (Nhớ mở comment)
      HandleLoadingPage();

      const oldData = props.DataPlanHandleStep.responsePlan
        .map((item) => {
          return { ...item, content: item.content ? item.content : "" };
        })
        .filter((item) => {
          return item.typeParam !== "Input" && item.type !== "Link liên kết";
        });
      updatedData = updatedData.map((item) => {
        return { ...item, content: item.content ? item.content : "" };
      });

      var difference = updatedData.filter(function (o1) {
        return !oldData.some(function (o2) {
          return o1.name === o2.name && o1.content === o2.content; // return the ones with equal id
        });
      });

      //let difference = updatedData.filter(({ content: id1 }) => !  oldData.some(({ content: id2 }) => id2 === id1));

      await difference.forEach((updateItem, i) => {
        let oldContent = "";
        oldData.forEach((currentItem, i) => {
          if (updateItem.name === currentItem.name) {
            oldContent = currentItem.content;
            updateItem.OldContent = oldContent;
          }
        });
      });

      //return;

      /*== Cấu hình date, do khi truyền vào stringify sẽ bị sai ngày ==*/
      var today = new Date();

      var date =
        today.getDate() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getFullYear();

      var time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

      var dateTime = date + " " + time;

      /*====== Tạo object chứa các thông tin ghi log ======*/
      const object = (planID, handleStaff, date, action, step, difference) => {
        return {
          planID: planID,
          handleStaff: handleStaff,
          date: date,
          action: action,
          step: step,
          difference: difference,
        };
      };
      const logs = object(
        currentData.responsePlan[0].planID,
        currentData.handleStaff[0],
        dateTime,
        item.name,
        currentData.responsePlan[0].handleStep,
        difference
      );

      props.SetDataPlanHandleStep({
        Data: JSON.stringify({
          PlanContent: updatedData.filter((item) => {
            return item.disabled === 0;
          }),
          Action: item.component,
          PlanTypeConfigurationMainID: item.planTypeConfigurationMainID,
        }),
        Action: item.component,
        logs: JSON.stringify(logs),
      });
    } else {
      props.SetDataPlanHandleStep({
        Data: JSON.stringify({
          PlanContent: updatedData.filter((item) => {
            return item.disabled === 0;
          }),
          Action: item.component,
          PlanTypeConfigurationMainID: item.planTypeConfigurationMainID,
        }),
        Action: item.component,
        logs: null,
      });
    }
    setOpenM(false);
  };

  const HandleLoadingPage = useCallback(() => {
    setIsLoading(true);
    // eslint-disable-next-line
  }, [DataPlanTypeConfiguration]);

  // const getOlDaTa = (name) => {
  //   let oldContent = "";
  //   currentData.responsePlan.forEach((item, i) => {
  //     if (name === item.name) {
  //       oldContent = item.content;
  //       return oldContent;
  //     }
  //     return oldContent;
  //   });
  // };

  /*=============================================================================================
   Summary:     action show log khi click vào button lịch sử thao tác
   Author:      Sangvtt2
   Date:        04-04-2022 
   =============================================================================================*/
  // const showLogs = async () => {

  //   setIsOpenHistory(true);
  //   await props.GetHistoryByPlanID(id);
  //   // if (!isOpenHistory) {
  //   //   props.GetHistoryByPlanID(id);
  //   // }
  //   // // đang set isOpenHistory = khác chính nó
  //   // setIsOpenHistory(!isOpenHistory);
  // };

  useEffect(() => {
    props.GetHistoryByPlanID(id)
    // eslint-disable-next-line
  }, [id])

  useEffect(() => {
    setDataHistory(props.DataHistory)
    return () => {
      setDataHistory()
    }
  }, [id, props.DataHistory])

  const showLogs = useCallback((event) => {
    setAnchorEl(event.currentTarget)
    setShoboxMoreAnchorEl(null)
    // event.stopPropagation()
    setDataHistory(props.DataHistory)
    if (dataHistory && dataHistory.length > 0) {
      setIsOpenHistory(!isOpenHistory);
    } else {
      NotificationManager.warning('Chưa có thông tin lịch sử thao tác');
    }
    // await props.GetHistoryByPlanID(id);
    // if (!isOpenHistory) {
    //   props.GetHistoryByPlanID(id);
    // }
    // // đang set isOpenHistory = khác chính nó
    // setIsOpenHistory(!isOpenHistory);
    // eslint-disable-next-line
  }, [id, dataHistory])


  // useEffect(() => {
  //   if (props.DataHistory === undefined) {


  //   }
  //   else if (props.DataHistory && Object.keys(props.DataHistory).length > 0) {

  //   }
  //   else {
  //     NotificationManager.error('Chưa có thông tin lịch sử thao tác');
  //   }
  // }, [props.DataHistory])

  /*=============================================================================================
  Summary:     action close btn history
  Author:      Sangvtt2
  Date:        09-05-2022 
  =============================================================================================*/
  const closeBtnHistory = () => {
    setIsOpenHistory(!isOpenHistory);
    setAnchorEl(null)
    setShoboxMoreAnchorEl(null)
  }

  /*=============================================================================================
    Summary:     Hiển thị các thông tin bị disable 
    Author:      Sangvtt2
    Date:        05-04-2022 
    =============================================================================================*/
  const showInfoDisable = useCallback(() => {
    setIsLoading(true);
    setIsOpenInfoDisable(!isOpenInfoDisable)
    setTimeout(() => setIsLoading(false), 1000)
  }, [isOpenInfoDisable]);

  const HandleOpenShowBoxHistory = (event) => {
    setShoboxMoreAnchorEl(event.currentTarget)
    event.stopPropagation()
  }

  const HandleCloseHistory = (currentTarget) => {
    if (anchorEl && currentTarget !== anchorEl) {
      setIsOpenHistory(false)
      setAnchorEl(null)
    } else if (shoboxMoreAnchorEl && currentTarget !== shoboxMoreAnchorEl) {
      setIsOpenHistory(false)
      setShoboxMoreAnchorEl(null)
    }
  }
  const handleWheel = () => {
    if (window.document.body.scrollHeight <= window.screen.availHeight) {
      setDown(true);
    }
    else if (window.pageYOffset <= 700) {
      setDown(false);
    }
    else if (window.pageYOffset >= 1500 && window.pageYOffset <= 5000) {
      setDown(true);
    }
  }

  const BackToBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth',
    })
    setDown(true);
  };
  const handleScrollTop = () => {
    setDown(false);
  }

  if (!DataPlanTypeConfiguration || !handleStaff) {
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <TwinSpin color="#6FB554" width="50px" height="50px" duration="0.5s" />
      </div>
    );
  }
  return (
    <div className="plan-handle-step" onWheel={() => handleWheel()} onClick={(event) => HandleCloseHistory(event.currentTarget)}>
      {/* <h1 className="project-name" style={{top: "2%", position : 'fixed', zIndex: '1000000', fontSize : '25px'}}>{projectName}</h1> */}
      <ScrollToTop smooth color="white" style={{ fontWeight: 'bold', backgroundColor: 'rgb(160,160,160)', right: '0.5%' }} onMouseMove={() => handleScrollTop()} />
      <div style={{ float: 'right', marginRight: '1.6%' }}>
        <button onClick={() => BackToBottom()} style={{ boxShadow: '0 9px 25px 0 rgb(132 128 177 / 28%', visibility: isDown ? 'hidden' : 'visible', display: 'block', backgroundColor: 'rgb(169,169,169)', position: 'fixed', zIndex: 2, cursor: 'pointer', borderRadius: '7px', height: '40px', width: '40px', border: 'none' }} >< BsArrowDown style={{ fontWeight: 'bold', height: '30px', width: '30px', fontSize: '40px', color: 'white', float: 'right' }} /></button>
      </div>
      <div className={classes.root}>
        <Stepper activeStep={handleStep} alternativeLabel>
          {steps &&
            steps.map((label, index) => (
              <Step
                className={isChoosenStep - 1 === index ? "is-active-step" : ""}
                key={index}
                onClick={() => HandelChangeStep(index)}
              >
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
        </Stepper>
        {open || isLoading ? (
          <div className="isLoading-wrapper" style={{ width: "100%" }}>
            {" "}
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <TwinSpin
                color="#6FB554"
                width="50px"
                height="50px"
                duration="0.5s"
              />
            </div>{" "}
          </div>
        ) : (
          <div className="plan-template-new-body">
            <div className="divBtnShowInfoDisable">
              <Button
                style={{
                  margin: "0 2.5px",
                  backgroundColor: "#FFFFFF",
                  color: "#6FB554",
                  width: "auto"
                }}
                variant="contained"
                className="btnHistory"
                onClick={() => showInfoDisable()}
                startIcon={<MdOutlineDisabledVisible />}
              >
                <text style={{ color: "#6FB554", fontSize: "17px" }}>
                  {isOpenInfoDisable ? 'Ẩn thông tin kế hoạch' : 'Hiện thông tin kế hoạch'}
                </text>
              </Button>
            </div>

            {statusHistory ? (
              <div className="areaButtonHistory">
                {/* {console.log("props", props)} */}
                <Button
                  style={{
                    margin: "0 2.5px",
                    backgroundColor: "#FFFFFF",
                    color: "#6FB554",
                    width: "200px"
                  }}
                  variant="contained"
                  className="btnHistory"
                  onClick={(event) => showLogs(event)}
                  startIcon={<MdHistory />}
                >
                  <text style={{ color: "#6FB554", fontSize: "17px" }}>
                    Lịch sử thao tác
                  </text>
                </Button>
              </div>
            ) : null}

            {isOpenHistory &&
              dataHistory &&
              Object.keys(dataHistory).length > 0 && (
                <div id="areHistory" className="history">

                  <MdClose style={{
                    color: "white", fontSize: "large",
                    border: "1px solid red", borderRadius: "20px", backgroundColor: "red",
                    margin: "-5px 0 0 0", position: "absolute",
                    right: "0"
                  }}
                    onClick={() => closeBtnHistory()}
                  />

                  {dataHistory &&
                    dataHistory.map((item, index) => {
                      // console.log(item);
                      return (
                        <div className="history-item" onClick={(event) => { HandleOpenShowBoxHistory(event) }}>
                          <div className="history-item-title">
                            <MdPermIdentity
                              color="#86b2dc"
                              style={{ fontSize: "x-large" }}
                            />{" "}
                            <div className="name">
                            {item.handleStaff.includes('@fpt.com.vn') ? item.handleStaff.replace("@fpt.com.vn", "") : item.handleStaff.replace("@fpt.com", "")}
                            </div>
                            <div
                              className="Date"
                              style={{ fontStyle: "italic", color: "grey" }}
                            >
                              {item.date}
                            </div>
                          </div>

                          <div className="group">
                            <MdOutlineCallToAction color="#FF8C00" />
                            <lablel className="historyLabel">Tác vụ </lablel>
                            <div
                              className="TacVu"
                              style={{ fontWeight: "bold", marginLeft: "10px" }}
                            >
                              {item.action}
                            </div>
                          </div>

                          <div className="group">
                            <MdOutlineLocationOn color="#FF8C00" />
                            <lablel className="historyLabel">Vị trí </lablel>
                            <div
                              className="ViTri"
                              style={{ fontWeight: "bold", marginLeft: "10px" }}
                            >
                              Bước {item.step}{" "}
                            </div>
                          </div>

                          {item.difference.map((item1, index1) => {
                            return (
                              <div className="change">
                                <div
                                  className="group"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <BsPencilFill color="#78ba5f" />
                                  <lablel className="historyLabel">
                                    Thay đổi
                                  </lablel>
                                  <div
                                    className="ViTri"
                                    style={{
                                      marginLeft: "10px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {item1.name}
                                  </div>
                                </div>

                                {/* {console.log("item1.OldContent", item1.OldContent)}
                                                    {console.log("item1.content", item1.content)} */}
                                <div className="dataChange">
                                  <div
                                    className="oldData"
                                    dangerouslySetInnerHTML={{
                                      // __html: item1.OldContent==null  ? item1.OldContent : "NULL"

                                      __html:
                                        item1.OldContent == null ||
                                          item1.OldContent === ""
                                          ? "NULL"
                                          : item1.OldContent,
                                    }}
                                  ></div>

                                  <MdOutlineArrowDownward color="#86b2dc" />
                                  <div
                                    className="newData"
                                    dangerouslySetInnerHTML={{
                                      // __html: item1.content !== "" ? item1.content : "NULL"

                                      __html:
                                        item1.content == null ||
                                          item1.content === ""
                                          ? "NULL"
                                          : item1.content,
                                    }}
                                  ></div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                    })}
                </div>
              )}

            {/* {console.log("DataPlanTypeConfiguration", DataPlanTypeConfiguration.map((item, index) => { return { ...item, content: item.content ? item.content : "" } }))} */}
            {isOpenInfoDisable ? (
              <div style={{ width: "100%" }}>
                <fieldset
                  className="border p-2"
                  style={{
                    borderRadius: "15px",
                    margin: "auto 25px 15px auto",
                    width: "98%",
                    fontWeight: "900",
                  }}
                >
                  <legend
                    className="w-auto text-left"
                    style={{ fontSize: "inherit", color: "grey" }}
                  >
                    Thông tin kế hoạch
                  </legend>


                  <RenderLayout
                    data={DataPlanTypeConfiguration.filter((item) => {
                      if (!item.content && item.type === "Datetime") {
                        item.content = `${HandleCovertDateTime(new Date())} ${new Date().toLocaleTimeString('en-GB', { hour: 'numeric', minute: 'numeric' })}`
                        return item
                      }
                      return item.disabled === 1 && item.name !== "Nhân viên phụ trách";
                    })}
                    onChange={HandleOnChange}
                    handleDownload={handleDownload}
                    currentEmailAzure={currentEmailAzure}
                    handleGetInputTextAzureEmail={handleGetInputTextAzureEmail}
                    currentValue={currentValue}
                    handleUpdateStateDataPlanHandle={handleUpdateStateDataPlanHandle}
                  />
                </fieldset>

                <RenderLayout
                  data={DataPlanTypeConfiguration.filter((item) => {
                    if (!item.content && item.type === "Datetime") {
                      item.content = `${HandleCovertDateTime(new Date())} ${new Date().toLocaleTimeString('en-GB', { hour: 'numeric', minute: 'numeric' })}`
                      return item
                    }
                    return item.disabled === 0 || item.name === "Nhân viên phụ trách";
                  })}
                  onChange={HandleOnChange}
                  handleDownload={handleDownload}
                  currentEmailAzure={currentEmailAzure}
                  handleGetInputTextAzureEmail={handleGetInputTextAzureEmail}
                  currentValue={currentValue}
                  handleUpdateStateDataPlanHandle={handleUpdateStateDataPlanHandle}
                />
              </div>
            ) : (
              <div style={{ width: "100%" }}>
                <RenderLayout
                  data={DataPlanTypeConfiguration.filter((item) => {
                    if (!item.content && item.type === "Datetime") {
                      item.content = `${HandleCovertDateTime(new Date())} ${new Date().toLocaleTimeString('en-GB', { hour: 'numeric', minute: 'numeric' })}`
                      return item
                    }
                    return item.disabled === 0 || item.name === "Nhân viên phụ trách";
                  })}
                  onChange={HandleOnChange}
                  handleDownload={handleDownload}
                  currentEmailAzure={currentEmailAzure}
                  handleGetInputTextAzureEmail={handleGetInputTextAzureEmail}
                  currentValue={currentValue}
                  handleUpdateStateDataPlanHandle={handleUpdateStateDataPlanHandle}
                />
              </div>
            )}

            {/* <RenderLayout data={DataPlanTypeConfiguration} onChange={HandleOnChange} handleDownload={handleDownload} /> */}
            {/* {(handleStaff.includes(cookies.get('usercode').email) || DataPlanTypeConfiguration[0].createBy === cookies.get('usercode').userCode) && status === 0 && handleStep === activeStep && <div className="action"> */}
            {
              status === 0 &&
              handleStep <= activeStep &&
              (
                <div className="action">
                  {!isLoading &&
                    actions.map((item, index) => (
                      <Action
                        isShow={(handleStep === activeStep || item.component === "PLAN_SAVE") && handleStaff.includes(cookies.get('usercode').email) ? false : true}
                        label={
                          JSON.parse(item.propsJson).rename
                            ? JSON.parse(item.propsJson).rename
                            : item.name
                        }
                        backgroundColor={
                          (handleStep === activeStep || item.component === "PLAN_SAVE") && handleStaff.includes(cookies.get('usercode').email) ? JSON.parse(item.propsJson).backgroundColor : '#C0C0C0'
                        }
                        borderColor={JSON.parse(item.propsJson).borderColor}
                        status="USE"
                        type={item.component}
                        //onClick={()=>props.SetDataPlanHandleStep({Data: JSON.stringify({ PlanContent: DataPlanTypeConfiguration.filter(item => { return item.disabled === 0 }), Action: item.component, PlanTypeConfigurationMainID: item.planTypeConfigurationMainID }), Action: item.component })}
                        // onClick={() => checkAndUpdate(DataPlanTypeConfiguration, item)}
                        onClick={() =>
                          handleClickOpen(DataPlanTypeConfiguration, item)
                        }
                      />
                    ))}
                  <Dialog
                    open={openM}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle
                      id="alert-dialog-title"
                      className="popupHandle"
                    >
                      {titleDialog}
                      <IconButton
                        style={{ marginLeft: 250 }}
                        onClick={handleClose}
                      >
                        <MdClose />
                      </IconButton>
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText
                        id="alert-dialog-description"
                        style={{ textAlign: "center" }}
                      >
                        <p>{nameAction}</p>
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        className="PlanTemplate_0021 text-light"
                        onClick={() =>
                          HandleValidateField(dataPlanTypeConfig, itemAction)
                        }
                        style={{ backgroundColor: "#6FB554" }}
                        autoFocus
                      >
                        Đồng ý
                      </Button>
                      <Button
                        className="PlanTemplate_0021 text-light"
                        style={{ backgroundColor: "#DA9630" }}
                        onClick={handleClose}
                      >
                        Đóng
                      </Button>
                    </DialogActions>
                  </Dialog>
                </div>
              )}
          </div>
        )}
      </div>
    </div>
  );
}
